import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

export default function Loading() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}>
      <CircularProgress />
    </Box>
  )
}
